import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as empresaRoutes } from './empresas/routes';
import { routes as clusterRoutes } from './clusters/routes';
import { routes as projectRoutes } from './projects/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as aiAgentsRoutes } from './aiAgents/aiAgents.routes';
import { routes as knowledgeRoutes } from './knowledge/knowledge.routes';
import { routes as ticketRoutes } from './tickets/routes';
import { routes as contractRoutes } from './contracts/routes';
import { routes as appBuilderRoutes } from './appBuilder/routes';
import { routes as orderRoutes } from './orders/routes';
import { routes as taskRoutes } from './tasks/routes';
import { routes as issueClusterRoutes } from './issueClusters/routes';
import { routes as tramiteRoutes } from './tramites/routes';
import { routes as appsRoutes } from './apps/routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...aiAgentsRoutes,
        ...knowledgeRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...empresaRoutes,
        ...clusterRoutes,
        ...projectRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...ticketRoutes,
        ...contractRoutes,
        ...appBuilderRoutes,
        ...orderRoutes,
        ...taskRoutes,
        ...issueClusterRoutes,
        ...tramiteRoutes,
        ...appsRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
